import { lazyLoadView } from '@router/helpers';
export default [
  {
    path: '/i/:id(\\d+)/kelas-diklat',
    name: 'kelas-diklat',
    component: () => lazyLoadView(import('@views/instansi/kelas/Main')),
    meta: {
      title: 'Daftar Kelas Diklat Daring',
      jenis: 'daring',
    },
  },
  {
    path: '/i/:id(\\d+)/kelas-diklat-luring',
    name: 'kelas-diklat-luring',
    component: () => lazyLoadView(import('@views/instansi/kelas/Main')),
    meta: {
      title: 'Daftar Kelas Diklat Luring',
      jenis: 'luring',
    },
  },
  {
    path: '/i/:id(\\d+)/kelas-peserta-luring',
    name: 'kelas-peserta-luring',
    component: () => lazyLoadView(import('@views/instansi/kelas/peserta/Index')),
    meta: {
      title: 'Daftar Kelas Diklat Luring',
      jenis: 'luring',
    },
  },
  {
    path: '/i/:id(\\d+)/kelas-peserta-luring/:kelas_id',
    name: 'kelas-peserta-luring-detail',
    component: () => lazyLoadView(import('@views/instansi/kelas/peserta/Detail')),
    meta: {
      title: 'Detail Kelas Diklat Luring',
      jenis: 'luring',
    },
  },
  {
    path: '/i/:id(\\d+)/kelas-diklat-bcmp',
    name: 'kelas-diklat-bcmp',
    component: () => lazyLoadView(import('@views/instansi/kelas/Main')),
    meta: {
      title: 'Daftar Kelas Diklat BCMP',
      jenis: 'bcmp',
    },
  },
  {
    path: '/i/:id(\\d+)/kelas-diklat-bimtek',
    name: 'kelas-diklat-bimtek',
    component: () => lazyLoadView(import('@views/instansi/kelas/Main')),
    meta: {
      title: 'Daftar Kelas Diklat Bimtek',
      jenis: 'bimtek',
    },
  },
  {
    path: '/i/:id(\\d+)/kelas',
    name: 'kelas',
    component: () => lazyLoadView(import('@views/instansi/kelas/list/Index')),
    meta: {
      title: 'Daftar Kelas Diklat Daring',
      jenis: 'daring',
    },
  },
  {
    path: '/i/:id(\\d+)/kelas-luring',
    name: 'kelas-luring',
    component: () => lazyLoadView(import('@views/instansi/kelas/list/Index')),
    meta: {
      title: 'Daftar Kelas Diklat Luring',
      jenis: 'luring',
    },
  },
  {
    path: '/i/:id(\\d+)/kelas-luring-peserta/:kelas_id',
    name: 'kelas-luring-peserta',
    component: () => lazyLoadView(import('@views/instansi/kelas/Detail')),
    meta: {
      title: 'Kelas Diklat',
      jenis: 'luring',
    },
  },
  {
    path: '/i/:id(\\d+)/kelas-bcmp-peserta/:kelas_id',
    name: 'kelas-bcmp-peserta',
    component: () => lazyLoadView(import('@views/instansi/peserta/formulir/Detail')),
    meta: {
      title: 'Kelas Diklat',
      jenis: 'bcmp',
    },
  },
  {
    path: '/i/:id(\\d+)/kelas-luring-laporan/:kelas_id',
    name: 'kelas-luring-laporan',
    component: () => lazyLoadView(import('@views/instansi/kelas/Laporan')),
    meta: {
      title: 'Kelas Diklat',
      jenis: 'luring',
    },
  },
];
